import api from "api/api";

export const createContractualStatus = async (data) =>
  await api.post("settings/contractual_status", data);

export const getContractualStatusList = async () =>
  await api.get("/settings/contractual_status");

export const getContractualStatusById = async (id) =>
  await api.get(`settings/contractual_status/${id}`);

export const updateContractualStatusById = async (id, data) =>
  await api.put(`/settings/contractual_status/${id}`, data);

export const deleteContractualStatusById = async (id) =>
  await api.delete(`/settings/contractual_status/${id}`);
